import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { ErrorPageDirective } from './error-page.directive';
import { InternalServerErrorComponent } from './internal-server-error/internal-server-error.component';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
   declarations: [ErrorPageDirective, NotFoundComponent, InternalServerErrorComponent],
   exports: [ErrorPageDirective, NotFoundComponent, InternalServerErrorComponent],
   imports: [MatButtonModule, RouterModule],
})
export class ErrorPageModule {}
